import { call, put, takeLatest } from 'redux-saga/effects';

import { getIncomeTypes } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData(action) {
  const response = yield call(getIncomeTypes, action.year);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* incomeTypesSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
